import { render } from "./OfferPromo.vue?vue&type=template&id=64077b7e"
import script from "./OfferPromo.vue?vue&type=script&lang=js"
export * from "./OfferPromo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__